function Loader() {
  return (
    <div className="d-flex justify-content-center">
      <div className="spinner-border spinner-border-m text-info pl-4"></div>
    </div>
  );
}

export default Loader;
